module.exports = {
    Update_All_Data: "Update_All_Data"
    , Video_Data_Event: "Video_Data_Event"
    , Fight_Success_Event: "Fight_Success_Event"
    ,Count_Change_Event: "Count_Change_Event"
    ,Update_Top3_rank: "Update_Top3_rank"
    ,Update_Reward_Event: "Update_Reward_Event"
    ,Update_First_Reward_Msg: "Update_First_Reward_Msg"//推送首通奖励变化

}